import { CircularProgress } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { useTheme, makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { Cell, Pie, PieChart } from "recharts";
import { DDATheme } from "src/types/Theme";

const useStyles = makeStyles(() => ({
  noData: {
    fontStyle: "italic",
    color: "#666666",
    textAlign: "center",
    fontSize: "1rem",
    marginTop: "20px",
  },
  title: {
    textAlign: "center",
    color: "#666666",
  },
  label: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translate(-45%)",
    color: "#666666",
  },
  zeroPercent: {
    position: "absolute",
    left: 28,
    bottom: 0,
    color: "#666666",
    fontSize: "1rem",
  },
  hundretPercent: {
    position: "absolute",
    right: 0,
    bottom: 0,
    color: "#666666",
    fontSize: "1rem",
  },
  maxValueLabel: {
    width: 350,
    position: "absolute",
    left: 0,
    bottom: -50,
    marginLeft: "5px",
    color: "#666666",
    fontSize: "1rem",
    textAlign: "center",
  },
  circularProgressWrapper: {
    width: 350,
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

interface Props {
  title: string;
  value?: number;
  maxValue?: number;
  labelMaxValue?: string;
}

const GaugeChart: React.FC<Props> = ({
  title,
  value,
  maxValue,
  labelMaxValue,
}: Props) => {
  const theme = useTheme<DDATheme>();
  const classes = useStyles();
  const [chartData, setChartData] = useState<Array<{ value: number }>>([]);
  const [label, setLabel] = useState<string>("");
  const [noDataAvailable, setNoDataAvailable] = useState(false);

  useEffect(() => {
    if (value !== undefined && maxValue !== undefined) {
      if (maxValue === 0) {
        setNoDataAvailable(true);
      } else {
        const restValue = maxValue - value;
        setChartData([{ value }, { value: restValue }]);
        setLabel(`${((value / maxValue) * 100).toFixed(1)}%`.replace(".", ","));
      }
    }
  }, [value, maxValue]);

  const GaugeChartContent = (): JSX.Element => {
    return (
      <>
        <PieChart width={350} height={150}>
          <Pie
            data={chartData}
            isAnimationActive={false}
            cx={175}
            cy={140}
            startAngle={180}
            endAngle={0}
            innerRadius={80}
            outerRadius={120}
            paddingAngle={0}
            fill="#8884d8"
            dataKey="value"
          >
            <Cell fill={"#3c78aa"} />
            <Cell fill={"#dddddd"} />
          </Pie>
        </PieChart>
        <Typography variant="h4" className={classes.label}>
          {label}
        </Typography>
        <Typography className={classes.zeroPercent}>0%</Typography>
        <Typography className={classes.hundretPercent}>100%</Typography>
        {labelMaxValue && (
          <Typography className={classes.maxValueLabel}>
            {`${labelMaxValue}: `}
            <span style={{ fontWeight: 600 }}>{maxValue}</span>
          </Typography>
        )}
      </>
    );
  };

  const NoData = (): JSX.Element => {
    return <div className={classes.noData}> Keine Daten vorhanden </div>;
  };
  return (
    <>
      {chartData.length || noDataAvailable ? (
        <div style={{ position: "relative", width: 350 }}>
          <Typography variant="subtitle1" className={classes.title}>
            {title}
          </Typography>
          {noDataAvailable ? <NoData /> : <GaugeChartContent />}
        </div>
      ) : (
        <div className={classes.circularProgressWrapper}>
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default GaugeChart;



// WEBPACK FOOTER //
// ./src/components/generic/GaugePercentChart.tsx